// export const ThirdPartyService_URL = 'http://localhost:9010';
// export const OrderManagementService_URL = "http://localhost:9100";
// export const CustomerService_URL = 'http://localhost:9070';
// export const AdminService_URL = "http://localhost:9001";
// export const AdminService_URL = "https://111.119.215.158:9103";
//export const DoctorService_URL='http://192.168.0.106:8070';

// export const PharmacistService_URL = 'http://192.168.0.182:9090';
// export const OrderManagementService_URL = 'http://192.168.0.182:9100';
// export const Image_URL='http://192.168.0.182:9080';

// export const PharmacistService_URL = 'http://192.168.0.53:9090';
// export const OrderManagementService_URL = 'http://192.168.0.53:9100';

// export const PharmacistService_URL = 'http://192.168.0.170:8080/PharmacistService';
// export const OrderManagementService_URL = 'http://192.168.x0.170:8080/OrderManagementService';
// export const CustomerService_URL = 'http://192.168.0.170:8080/CustomerService';

// export const Image_URL='https://services.truemeds.in';
// export const AdminService_URL='https://services.tmmumbai.in/AdminService';

// Production urls start
// export const Image_URL =
//   "https://tm-storage-bucket-prod.s3.ap-south-1.amazonaws.com/";
// export const AdminService_URL = "https://api.tmmumbai.in/AdminService";

// export const ThirdPartyService_URL =
//   "https://api.tmmumbai.in/ThirdPartyService";
// export const PharmacistService_URL =
//   "https://api.tmmumbai.in/PharmacistService";
// export const OrderManagementService_URL =
//   "https://api.tmmumbai.in/OrderManagementService";
// export const CustomerService_URL = "https://api.tmmumbai.in/CustomerService";
// export const DoctorService_URL = "https://api.tmmumbai.in/DoctorService";
// export const CsrService_URL = "https://api.tmmumbai.in/CsrService";
// export const ElasticSearch_URL =
//   "https://search-tm-prod-es-fk6ngihhkktmll4mo2h4xyyw4u.ap-south-1.es.amazonaws.com";

// export const OauthService_URL = "https://api.tmmumbai.in/OauthService";
// export const VendorConstant = "";
//Production urls end

//Stage urls start
// export const Image_URL =
//   "https://tm-storage-bucket-stage.s3.ap-south-1.amazonaws.com/";
// export const AdminService_URL =
//   "https://stage-services.truemeds.in/AdminService";
// export const ThirdPartyService_URL =
//   "https://stage-services.truemeds.in/ThirdPartyService";
// export const PharmacistService_URL =
//   "https://stage-services.truemeds.in/PharmacistService";
// export const OrderManagementService_URL =
//   "https://stage-services.truemeds.in/OrderManagementService";
// export const CustomerService_URL =
//   "https://stage-services.truemeds.in/CustomerService";
// export const DoctorService_URL =
//   "https://stage-services.truemeds.in/DoctorService";
// export const CsrService_URL = "https://stage-services.truemeds.in/CsrService";
// export const ElasticSearch_URL =
//   "https://search-tm-stage-es-nnmfrbwdug6zoksvm6pkvbz7ga.ap-south-1.es.amazonaws.com";
// export const OauthService_URL =
//   "https://stage-services.truemeds.in/OauthService";
// export const VendorConstant = " Stage";

// export const AdminService_NEW_URL = "https://nal1.tmmumbai.in/AdminService";
// export const ThirdPartyService_NEW_URL =
//   "https://nal1.tmmumbai.in/ThirdPartyService";
// export const PharmacistService_NEW_URL =
//   "https://nal1.tmmumbai.in/PharmacistService";
// export const OrderManagementService_NEW_URL =
//   "https://nal1.tmmumbai.in/OrderManagementService";
// export const CustomerService_NEW_URL =
//   "https://nal1.tmmumbai.in/CustomerService";
// export const DoctorService_NEW_URL = "https://nal1.tmmumbai.in/DoctorService";
// export const CsrService_NEW_URL = "https://nal1.tmmumbai.in/CsrService";
// export const ElasticSearch_NEW_URL =
//   "https://search-tm-stage-es-nnmfrbwdug6zoksvm6pkvbz7ga.ap-south-1.es.amazonaws.com";
// export const OauthService_NEW_URL = "https://nal1.tmmumbai.in/OauthService";
//Stage urls end

// uat urls start
// export const Image_URL =
//   "https://tm-storage-bucket-uat.s3.ap-south-1.amazonaws.com/";
// export const AdminService_URL = "https://uat-services.truemeds.in/AdminService";
// export const ThirdPartyService_URL =
//   "https://uat-services.truemeds.in/ThirdPartyService";
// export const PharmacistService_URL =
//   "https://uat-services.truemeds.in/PharmacistService";
// export const OrderManagementService_URL =
//   "https://uat-services.truemeds.in/OrderManagementService";
// export const CustomerService_URL =
//   "https://uat-services.truemeds.in/CustomerService";
// export const DoctorService_URL =
//   "https://uat-services.truemeds.in/DoctorService";
// export const CsrService_URL = "https://uat-services.truemeds.in/CsrService";
// export const ElasticSearch_URL =
//   "https://search-tm-uat-es-leogrdupczbaam4y3vupjxctti.ap-south-1.es.amazonaws.com";
// export const OauthService_URL = "https://uat-services.truemeds.in/OauthService";
// export const VendorConstant = " UAT";
// uat urls end

//Stage warehouse level urls start

//Stage urls end

import { TM_WAREHOUSES, currentEnv, warehouseId } from "../constants/index";

let baseUrl = "https://stage-services.truemeds.in/";
let secondaryBaseUrl = "https://stage-services.truemeds.in/";

let reportUrl = "https://stage-services.truemeds.in/";
let baseUrlNew = "https://nal1.tmmumbai.in/";
let imageUrl = "https://tm-storage-bucket-stage.s3.ap-south-1.amazonaws.com/";
let elasticUrl =
  "https://search-tm-stage-es-nnmfrbwdug6zoksvm6pkvbz7ga.ap-south-1.es.amazonaws.com";
let vendorConstant = " Stage";
let warehouseServiceUrl = "WarehouseMumbaiService";

switch (warehouseId) {
  //mumbai
  case 3:
    switch (currentEnv) {
      //prod
      case 1:
        baseUrl = "https://mum.truemedsapi.in/";
        baseUrlNew = "https://mum.truemedsapi.in/";
        reportUrl = "https://reports.tmmumbai.in/";
        imageUrl =
          "https://tm-storage-bucket-prod.s3.ap-south-1.amazonaws.com/";
        elasticUrl =
          "https://search-tm-prod-es-fk6ngihhkktmll4mo2h4xyyw4u.ap-south-1.es.amazonaws.com";
        vendorConstant = "";
        warehouseServiceUrl = "WarehouseMumbaiService";
        break;

      //uat
      case 2:
        baseUrl = "https://uat-services.truemeds.in/";
        baseUrlNew = "https://uat-services.truemeds.in/";
        reportUrl = "https://uat-services.truemeds.in/";
        imageUrl = "https://tm-storage-bucket-uat.s3.ap-south-1.amazonaws.com/";
        elasticUrl =
          "https://search-tm-uat-es-leogrdupczbaam4y3vupjxctti.ap-south-1.es.amazonaws.com";
        vendorConstant = " UAT";
        warehouseServiceUrl = "WarehouseMumbaiService";
        break;

      //stage
      case 3:
        baseUrl = "https://stage-android.truemedsapi.in/";
        baseUrlNew = "https://stage-android.truemedsapi.in/";
        reportUrl = "https://stage-android.truemedsapi.in/";
        imageUrl =
          "https://tm-storage-bucket-prod.s3.ap-south-1.amazonaws.com/";
        elasticUrl =
          "https://search-tm-prod-es-fk6ngihhkktmll4mo2h4xyyw4u.ap-south-1.es.amazonaws.com";
        vendorConstant = "";
        warehouseServiceUrl = "WarehouseMumbaiService";
        break;

      //uat
      case 4:
        baseUrl = "https://uat-services.truemeds.in/";
        baseUrlNew = "https://uat-services.truemeds.in/";
        imageUrl = "https://tm-storage-bucket-uat.s3.ap-south-1.amazonaws.com/";
        elasticUrl =
          "https://search-tm-uat-es-leogrdupczbaam4y3vupjxctti.ap-south-1.es.amazonaws.com";
        vendorConstant = " Stage";
        warehouseServiceUrl = "WarehouseMumbaiService";
        break;

      //stage - Normal
      case 5:
        baseUrl = "https://stage-android.truemedsapi.in/";
        baseUrlNew = "https://stage-android.truemedsapi.in/";
        imageUrl =
          "https://tm-storage-bucket-stage.s3.ap-south-1.amazonaws.com/";
        elasticUrl =
          "https://search-tm-stage-es-nnmfrbwdug6zoksvm6pkvbz7ga.ap-south-1.es.amazonaws.com";
        vendorConstant = " Stage";
        warehouseServiceUrl = "WarehouseMumbaiService";
        break;

      //stage - MUM
      case 6:
        baseUrl = "https://stage-android.truemedsapi.in/";
        baseUrlNew = "https://stage-android.truemedsapi.in/";
        imageUrl =
          "https://tm-storage-bucket-stage.s3.ap-south-1.amazonaws.com/";
        elasticUrl =
          "https://search-tm-stage-es-nnmfrbwdug6zoksvm6pkvbz7ga.ap-south-1.es.amazonaws.com";
        vendorConstant = " Stage";
        warehouseServiceUrl = "WarehouseMumbaiService";
        break;

      default:
        baseUrl = "https://mum.truemedsapi.in/";
        baseUrlNew = "https://mum.truemedsapi.in/";
        reportUrl = "https://reports.tmmumbai.in/";
        imageUrl =
          "https://tm-storage-bucket-stage.s3.ap-south-1.amazonaws.com/";
        elasticUrl =
          "https://search-tm-stage-es-nnmfrbwdug6zoksvm6pkvbz7ga.ap-south-1.es.amazonaws.com";
        vendorConstant = " Stage";
        warehouseServiceUrl = "WarehouseMumbaiService";
        break;
    }
    break;

  // ----------------- Mumbai New
  case 10:
    switch (currentEnv) {
      // ----------- PROD
      case 1:
        baseUrl = "https://mumwh.truemedsapi.in/";
        baseUrlNew = "https://mumwh.truemedsapi.in/";
        reportUrl = "https://reports.tmmumbai.in/";
        imageUrl =
          "https://tm-storage-bucket-prod.s3.ap-south-1.amazonaws.com/";
        elasticUrl =
          "https://search-tm-prod-es-fk6ngihhkktmll4mo2h4xyyw4u.ap-south-1.es.amazonaws.com";
        vendorConstant = "";
        warehouseServiceUrl = "WarehouseMumbaiService";
        break;

      // ----------- STAGE
      case 2:
        baseUrl = "https://stage-services.truemeds.in/";
        secondaryBaseUrl = "https://stage-services.truemeds.in/";
        baseUrlNew = "https://stage-services.truemeds.in/";
        reportUrl = "https://reports.tmmumbai.in/";
        imageUrl =
          "https://tm-storage-bucket-stage.s3.ap-south-1.amazonaws.com/";
        elasticUrl =
          "https://search-tm-stage-es-nnmfrbwdug6zoksvm6pkvbz7ga.ap-south-1.es.amazonaws.com";
        vendorConstant = " Stage";
        warehouseServiceUrl = "WarehouseMumbaiService";
        break;

      // ----------- STAGE-MUM
      case 3:
        baseUrl = "https://stage-mum.truemedsapi.in/";
        secondaryBaseUrl = "https://stage-mum.truemedsapi.in/";
        baseUrlNew = "https://stage-mum.truemedsapi.in/";
        reportUrl = "https://reports.tmmumbai.in/";
        imageUrl =
          "https://tm-storage-bucket-stage.s3.ap-south-1.amazonaws.com/";
        elasticUrl =
          "https://search-tm-stage-es-nnmfrbwdug6zoksvm6pkvbz7ga.ap-south-1.es.amazonaws.com";
        vendorConstant = " Stage";
        warehouseServiceUrl = "WarehouseMumbaiService";
        break;

      // ----------- STAGE-ANDROID
      case 4:
        baseUrl = "https://stage-android.truemedsapi.in/";
        secondaryBaseUrl = "https://stage-android.truemedsapi.in/";
        baseUrlNew = "https://stage-android.truemedsapi.in/";
        reportUrl = "https://reports.tmmumbai.in/";
        imageUrl =
          "https://tm-storage-bucket-stage.s3.ap-south-1.amazonaws.com/";
        elasticUrl =
          "https://search-tm-stage-es-nnmfrbwdug6zoksvm6pkvbz7ga.ap-south-1.es.amazonaws.com";
        vendorConstant = " Stage";
        warehouseServiceUrl = "WarehouseMumbaiService";
        break;

      // ----------- UAT
      case 5:
        baseUrl = "https://uat-services.truemeds.in/";
        baseUrlNew = "https://nal1.tmmumbai.in/";
        reportUrl = "https://reports.tmmumbai.in/";
        imageUrl = "https://tm-storage-bucket-uat.s3.ap-south-1.amazonaws.com/";
        elasticUrl =
          "https://search-tm-uat-es-leogrdupczbaam4y3vupjxctti.ap-south-1.es.amazonaws.com";
        vendorConstant = " UAT";
        warehouseServiceUrl = "WarehouseMumbaiService";
        break;

      // ----------- STAGE-QA
      case 6:
        baseUrl = "https://stage-qa.truemedsapi.in/";
        secondaryBaseUrl = "https://stage-qa.truemedsapi.in/";
        baseUrlNew = "https://stage-qa.truemedsapi.in/";
        reportUrl = "https://reports.tmmumbai.in/";
        imageUrl =
          "https://tm-storage-bucket-stage.s3.ap-south-1.amazonaws.com/";
        elasticUrl =
          "https://search-tm-stage-es-nnmfrbwdug6zoksvm6pkvbz7ga.ap-south-1.es.amazonaws.com";
        vendorConstant = " Stage";
        warehouseServiceUrl = "WarehouseMumbaiService";
        break;

      // ----------- PROD - New mumbai
      case 7:
        baseUrl = "https://mumwh.truemedsapi.in/";
        baseUrlNew = "https://mumwh.truemedsapi.in/";
        reportUrl = "https://reports.tmmumbai.in/";
        imageUrl =
          "https://tm-storage-bucket-prod.s3.ap-south-1.amazonaws.com/";
        elasticUrl =
          "https://search-tm-prod-es-fk6ngihhkktmll4mo2h4xyyw4u.ap-south-1.es.amazonaws.com";
        vendorConstant = "";
        warehouseServiceUrl = "WarehouseMumbaiService";
        break;

      default:
        baseUrl = "https://mumwh.truemedsapi.in/";
        baseUrlNew = "https://mumwh.truemedsapi.in/";
        reportUrl = "https://reports.tmmumbai.in/";
        imageUrl =
          "https://tm-storage-bucket-stage.s3.ap-south-1.amazonaws.com/";
        elasticUrl =
          "https://search-tm-stage-es-nnmfrbwdug6zoksvm6pkvbz7ga.ap-south-1.es.amazonaws.com";
        vendorConstant = " Stage";
        warehouseServiceUrl = "WarehouseMumbaiService";
        break;
    }
    break;

  //kolkata
  case 7:
  case 4:
    switch (currentEnv) {
      //prod
      case 1:
        baseUrl = "https://blr.truemedsapi.in/";
        baseUrlNew = "https://blr.truemedsapi.in/";
        reportUrl = "https://reports.tmmumbai.in/";
        imageUrl =
          "https://tm-storage-bucket-prod.s3.ap-south-1.amazonaws.com/";
        elasticUrl =
          "https://search-tm-prod-es-fk6ngihhkktmll4mo2h4xyyw4u.ap-south-1.es.amazonaws.com";
        vendorConstant = "";
        warehouseServiceUrl = "WarehouseMumbaiService";
        break;

      //stage
      case 3:
        baseUrl = "https://blr.truemedsapi.in/";
        baseUrlNew = "https://blr.truemedsapi.in/";
        reportUrl = "https://reports.tmmumbai.in/";
        imageUrl =
          "https://tm-storage-bucket-stage.s3.ap-south-1.amazonaws.com/";
        elasticUrl =
          "https://search-tm-stage-es-nnmfrbwdug6zoksvm6pkvbz7ga.ap-south-1.es.amazonaws.com";
        vendorConstant = " Stage";
        warehouseServiceUrl = "WarehouseMumbaiService";
        break;

      default:
        baseUrl = "https://blr.truemedsapi.in/";
        baseUrlNew = "https://blr.truemedsapi.in/";
        reportUrl = "https://reports.tmmumbai.in/";
        imageUrl =
          "https://tm-storage-bucket-stage.s3.ap-south-1.amazonaws.com/";
        elasticUrl =
          "https://search-tm-stage-es-nnmfrbwdug6zoksvm6pkvbz7ga.ap-south-1.es.amazonaws.com";
        vendorConstant = " Stage";
        warehouseServiceUrl = "WarehouseMumbaiService";
        break;
    }
    break;

  //Delhi
  case 5:
    switch (currentEnv) {
      //prod
      case 1:
        baseUrl = "https://del.truemedsapi.in/";
        baseUrlNew = "https://del.truemedsapi.in/";
        reportUrl = "https://reports.tmmumbai.in/";
        imageUrl =
          "https://tm-storage-bucket-prod.s3.ap-south-1.amazonaws.com/";
        elasticUrl =
          "https://search-tm-prod-es-fk6ngihhkktmll4mo2h4xyyw4u.ap-south-1.es.amazonaws.com";
        vendorConstant = "";
        warehouseServiceUrl = "WarehouseDelhiService";
        break;

      //stage
      case 3:
        baseUrl = "https://del.truemedsapi.in/";
        baseUrlNew = "https://del.truemedsapi.in/";
        reportUrl = "https://reports.tmmumbai.in/";
        imageUrl =
          "https://tm-storage-bucket-stage.s3.ap-south-1.amazonaws.com/";
        elasticUrl =
          "https://search-tm-stage-es-nnmfrbwdug6zoksvm6pkvbz7ga.ap-south-1.es.amazonaws.com";
        vendorConstant = " Stage";
        warehouseServiceUrl = "WarehouseDelhiService";
        break;

      default:
        baseUrl = "https://del.truemedsapi.in/";
        baseUrlNew = "https://del.truemedsapi.in/";
        reportUrl = "https://reports.tmmumbai.in/";
        imageUrl =
          "https://tm-storage-bucket-stage.s3.ap-south-1.amazonaws.com/";
        elasticUrl =
          "https://search-tm-stage-es-nnmfrbwdug6zoksvm6pkvbz7ga.ap-south-1.es.amazonaws.com";
        vendorConstant = " Stage";
        warehouseServiceUrl = "WarehouseDelhiService";
        break;
    }
    break;

  //Bangalore
  case 6:
    switch (currentEnv) {
      //prod
      case 1:
        baseUrl = "https://blr.truemedsapi.in/";
        baseUrlNew = "https://blr.truemedsapi.in/";
        reportUrl = "https://reports.tmmumbai.in/";
        imageUrl =
          "https://tm-storage-bucket-prod.s3.ap-south-1.amazonaws.com/";
        elasticUrl =
          "https://search-tm-prod-es-fk6ngihhkktmll4mo2h4xyyw4u.ap-south-1.es.amazonaws.com";
        vendorConstant = "";
        warehouseServiceUrl = "WarehouseBangaloreService";
        break;

      case 2:
        baseUrl = "https://uat-services.truemeds.in/";
        baseUrlNew = "https://uat-services.truemeds.in/";
        reportUrl = "https://uat-services.truemeds.in/";
        imageUrl = "https://tm-storage-bucket-uat.s3.ap-south-1.amazonaws.com/";
        elasticUrl =
          "https://search-tm-uat-es-leogrdupczbaam4y3vupjxctti.ap-south-1.es.amazonaws.com";
        vendorConstant = " UAT";
        warehouseServiceUrl = "WarehouseBangaloreService";
        break;

      //stage
      case 3:
        baseUrl = "https://stage-mum.truemedsapi.in/";
        baseUrlNew = "https://stage-mum.truemedsapi.in/";
        reportUrl = "https://stage-mum.truemedsapi.in/";
        imageUrl =
          "https://tm-storage-bucket-stage.s3.ap-south-1.amazonaws.com/";
        elasticUrl =
          "https://search-tm-stage-es-nnmfrbwdug6zoksvm6pkvbz7ga.ap-south-1.es.amazonaws.com";
        vendorConstant = " Stage";
        warehouseServiceUrl = "WarehouseBangaloreService";
        break;

      //stage - Normal
      case 5:
        baseUrl = "https://stage-services.truemeds.in/";
        baseUrlNew = "https://stage-services.truemeds.in/";
        imageUrl =
          "https://tm-storage-bucket-stage.s3.ap-south-1.amazonaws.com/";
        elasticUrl =
          "https://search-tm-stage-es-nnmfrbwdug6zoksvm6pkvbz7ga.ap-south-1.es.amazonaws.com";
        vendorConstant = " Stage";
        warehouseServiceUrl = "WarehouseBangaloreService";
        break;

      default:
        baseUrl = "https://blr.truemedsapi.in/";
        baseUrlNew = "https://blr.truemedsapi.in/";
        reportUrl = "https://reports.tmmumbai.in/";
        imageUrl =
          "https://tm-storage-bucket-stage.s3.ap-south-1.amazonaws.com/";
        elasticUrl =
          "https://search-tm-stage-es-nnmfrbwdug6zoksvm6pkvbz7ga.ap-south-1.es.amazonaws.com";
        vendorConstant = " Stage";
        warehouseServiceUrl = "WarehouseBangaloreService";
        break;
    }
    break;

  //kolkata
  case 8:
    switch (currentEnv) {
      //prod
      case 1:
        baseUrl = "https://blr.truemedsapi.in/";
        baseUrlNew = "https://blr.truemedsapi.in/";
        reportUrl = "https://reports.tmmumbai.in/";
        imageUrl =
          "https://tm-storage-bucket-prod.s3.ap-south-1.amazonaws.com/";
        elasticUrl =
          "https://search-tm-prod-es-fk6ngihhkktmll4mo2h4xyyw4u.ap-south-1.es.amazonaws.com";
        vendorConstant = "";
        warehouseServiceUrl = "WarehouseMumbaiService";
        break;

      //stage
      case 3:
        baseUrl = "https://blr.truemedsapi.in/";
        baseUrlNew = "https://blr.truemedsapi.in/";
        reportUrl = "https://reports.tmmumbai.in/";
        imageUrl =
          "https://tm-storage-bucket-stage.s3.ap-south-1.amazonaws.com/";
        elasticUrl =
          "https://search-tm-stage-es-nnmfrbwdug6zoksvm6pkvbz7ga.ap-south-1.es.amazonaws.com";
        vendorConstant = " Stage";
        warehouseServiceUrl = "WarehouseMumbaiService";
        break;

      default:
        baseUrl = "https://blr.truemedsapi.in/";
        baseUrlNew = "https://blr.truemedsapi.in/";
        reportUrl = "https://reports.tmmumbai.in/";
        imageUrl =
          "https://tm-storage-bucket-stage.s3.ap-south-1.amazonaws.com/";
        elasticUrl =
          "https://search-tm-stage-es-nnmfrbwdug6zoksvm6pkvbz7ga.ap-south-1.es.amazonaws.com";
        vendorConstant = " Stage";
        warehouseServiceUrl = "WarehouseMumbaiService";
        break;
    }
    break;

  // ----------------- Faridabad WH
  case TM_WAREHOUSES.FARIDABAD:
  case TM_WAREHOUSES.FARIDABAD_ANKW:
    switch (currentEnv) {
      // ----------- PROD
      case 1:
        baseUrl = "https://del.truemedsapi.in/";
        secondaryBaseUrl = "https://fdb.truemedsapi.in/";
        baseUrlNew = "https://del.truemedsapi.in/";
        reportUrl = "https://reports.tmmumbai.in/";
        imageUrl =
          "https://tm-storage-bucket-prod.s3.ap-south-1.amazonaws.com/";
        elasticUrl =
          "https://search-tm-prod-es-fk6ngihhkktmll4mo2h4xyyw4u.ap-south-1.es.amazonaws.com";
        vendorConstant = "";
        warehouseServiceUrl = "WarehouseDelhiService";
        break;

      // ----------- STAGE
      case 2:
        baseUrl = "https://stage-services.truemeds.in/";
        secondaryBaseUrl = "https://stage-services.truemeds.in/";
        baseUrlNew = "https://stage-services.truemeds.in/";
        reportUrl = "https://reports.tmmumbai.in/";
        imageUrl =
          "https://tm-storage-bucket-stage.s3.ap-south-1.amazonaws.com/";
        elasticUrl =
          "https://search-tm-stage-es-nnmfrbwdug6zoksvm6pkvbz7ga.ap-south-1.es.amazonaws.com";
        vendorConstant = " Stage";
        warehouseServiceUrl = "WarehouseMumbaiService";
        break;

      // ----------- STAGE-MUM
      case 3:
        baseUrl = "https://stage-mum.truemedsapi.in/";
        secondaryBaseUrl = "https://stage-mum.truemedsapi.in/";
        baseUrlNew = "https://stage-mum.truemedsapi.in/";
        reportUrl = "https://reports.tmmumbai.in/";
        imageUrl =
          "https://tm-storage-bucket-stage.s3.ap-south-1.amazonaws.com/";
        elasticUrl =
          "https://search-tm-stage-es-nnmfrbwdug6zoksvm6pkvbz7ga.ap-south-1.es.amazonaws.com";
        vendorConstant = " Stage";
        warehouseServiceUrl = "WarehouseMumbaiService";
        break;

      // ----------- STAGE-ANDROID
      case 4:
        baseUrl = "https://stage-android.truemedsapi.in/";
        secondaryBaseUrl = "https://stage-android.truemedsapi.in/";
        baseUrlNew = "https://stage-android.truemedsapi.in/";
        reportUrl = "https://reports.tmmumbai.in/";
        imageUrl =
          "https://tm-storage-bucket-stage.s3.ap-south-1.amazonaws.com/";
        elasticUrl =
          "https://search-tm-stage-es-nnmfrbwdug6zoksvm6pkvbz7ga.ap-south-1.es.amazonaws.com";
        vendorConstant = " Stage";
        warehouseServiceUrl = "WarehouseMumbaiService";
        break;

      // ----------- UAT
      case 5:
        baseUrl = "https://uat-services.truemeds.in/";
        baseUrlNew = "https://nal1.tmmumbai.in/";
        reportUrl = "https://reports.tmmumbai.in/";
        imageUrl = "https://tm-storage-bucket-uat.s3.ap-south-1.amazonaws.com/";
        elasticUrl =
          "https://search-tm-uat-es-leogrdupczbaam4y3vupjxctti.ap-south-1.es.amazonaws.com";
        vendorConstant = " UAT";
        warehouseServiceUrl = "WarehouseMumbaiService";
        break;

      // ----------- STAGE-QA
      case 6:
        baseUrl = "https://stage-qa.truemedsapi.in/";
        secondaryBaseUrl = "https://stage-qa.truemedsapi.in/";
        baseUrlNew = "https://stage-qa.truemedsapi.in/";
        reportUrl = "https://reports.tmmumbai.in/";
        imageUrl =
          "https://tm-storage-bucket-stage.s3.ap-south-1.amazonaws.com/";
        elasticUrl =
          "https://search-tm-stage-es-nnmfrbwdug6zoksvm6pkvbz7ga.ap-south-1.es.amazonaws.com";
        vendorConstant = " Stage";
        warehouseServiceUrl = "WarehouseMumbaiService";
        break;

      default:
        baseUrl = "https://del.truemedsapi.in/";
        secondaryBaseUrl = "https://fdb.truemedsapi.in/";
        baseUrlNew = "https://del.truemedsapi.in/";
        reportUrl = "https://reports.tmmumbai.in/";
        imageUrl =
          "https://tm-storage-bucket-prod.s3.ap-south-1.amazonaws.com/";
        elasticUrl =
          "https://search-tm-prod-es-fk6ngihhkktmll4mo2h4xyyw4u.ap-south-1.es.amazonaws.com";
        vendorConstant = "";
        warehouseServiceUrl = "WarehouseDelhiService";
        break;
    }
    break;

  default:
    switch (currentEnv) {
      //Prod
      case 1:
        baseUrl = "https://api.tmmumbai.in/";
        baseUrlNew = "https://nal.tmmumbai.in/";
        reportUrl = "https://reports.tmmumbai.in/";
        imageUrl =
          "https://tm-storage-bucket-prod.s3.ap-south-1.amazonaws.com/";
        elasticUrl =
          "https://search-tm-prod-es-fk6ngihhkktmll4mo2h4xyyw4u.ap-south-1.es.amazonaws.com";
        vendorConstant = "";
        warehouseServiceUrl = "WarehouseMumbaiService";
        break;

      //uat
      case 2:
        baseUrl = "https://uat-services.truemeds.in/";
        baseUrlNew = "https://nal1.tmmumbai.in/";
        reportUrl = "https://reports.tmmumbai.in/";
        imageUrl = "https://tm-storage-bucket-uat.s3.ap-south-1.amazonaws.com/";
        elasticUrl =
          "https://search-tm-uat-es-leogrdupczbaam4y3vupjxctti.ap-south-1.es.amazonaws.com";
        vendorConstant = " UAT";
        warehouseServiceUrl = "WarehouseMumbaiService";
        break;

      //stage
      case 3:
        baseUrl = "https://stage-services.truemeds.in/";
        baseUrlNew = "https://nal1.tmmumbai.in/";
        reportUrl = "https://reports.tmmumbai.in/";
        imageUrl =
          "https://tm-storage-bucket-stage.s3.ap-south-1.amazonaws.com/";
        elasticUrl =
          "https://search-tm-stage-es-nnmfrbwdug6zoksvm6pkvbz7ga.ap-south-1.es.amazonaws.com";
        vendorConstant = " Stage";
        warehouseServiceUrl = "WarehouseMumbaiService";
        break;

      //prod - old
      case 4:
        baseUrl = "https://api.tmmumbai.in/";
        baseUrlNew = "https://api.tmmumbai.in/";
        reportUrl = "https://reports.tmmumbai.in/";
        imageUrl =
          "https://tm-storage-bucket-prod.s3.ap-south-1.amazonaws.com/";
        elasticUrl =
          "https://search-tm-prod-es-fk6ngihhkktmll4mo2h4xyyw4u.ap-south-1.es.amazonaws.com";
        vendorConstant = "";
        warehouseServiceUrl = "WarehouseMumbaiService";
        break;

      //Uat - old
      case 5:
        baseUrl = "https://uat-services.truemeds.in/";
        baseUrlNew = "https://uat-services.truemeds.in/";
        reportUrl = "https://reports.tmmumbai.in/";
        imageUrl = "https://tm-storage-bucket-uat.s3.ap-south-1.amazonaws.com/";
        elasticUrl =
          "https://search-tm-uat-es-leogrdupczbaam4y3vupjxctti.ap-south-1.es.amazonaws.com";
        vendorConstant = " UAT";
        warehouseServiceUrl = "WarehouseMumbaiService";
        break;

      //stage - old
      case 6:
        baseUrl = "https://stage-android.truemedsapi.in/";
        baseUrlNew = "https://stage-android.truemedsapi.in/";
        reportUrl = "https://reports.tmmumbai.in/";
        imageUrl =
          "https://tm-storage-bucket-stage.s3.ap-south-1.amazonaws.com/";
        elasticUrl =
          "https://search-tm-stage-es-nnmfrbwdug6zoksvm6pkvbz7ga.ap-south-1.es.amazonaws.com";
        vendorConstant = " Stage";
        warehouseServiceUrl = "WarehouseMumbaiService";
        break;

      default:
        break;
    }
    break;
}

//for all other constants in case of warehouse

let Image_URL_var = imageUrl;
let AdminService_URL_var = baseUrl + "AdminService";
let ThirdPartyService_URL_var = baseUrl + "ThirdPartyService";
let PharmacistService_URL_var = baseUrl + "PharmacistService";
let OrderManagementService_URL_var = baseUrl + "OrderManagementService";
let CustomerService_URL_var = baseUrl + "CustomerService";
let DoctorService_URL_var = baseUrl + "DoctorService";
let CsrService_URL_var = baseUrl + "CsrService";
let ReportService_URL_var = reportUrl + "ReportsService";

let ElasticSearch_URL_var = elasticUrl;
let OauthService_URL_var = baseUrl + "OauthService";
let WarehouseMumbaiService_URL_var = baseUrl + warehouseServiceUrl;
let VendorConstant_var = vendorConstant;
let Picker_URL_var = secondaryBaseUrl + "PickerService";
let Checker_URL_var = secondaryBaseUrl + "CheckerService";
let Admin_URL_FDB_var = secondaryBaseUrl + "AdminService";

let AdminService_NEW_URL_var = baseUrlNew + "AdminService";
let ThirdPartyService_NEW_URL_var = baseUrlNew + "ThirdPartyService";
let PharmacistService_NEW_URL_var = baseUrlNew + "PharmacistService";
let OrderManagementService_NEW_URL_var = baseUrlNew + "OrderManagementService";
let CustomerService_NEW_URL_var = baseUrlNew + "CustomerService";
let DoctorService_NEW_URL_var = baseUrlNew + "DoctorService";
let CsrService_NEW_URL_var = baseUrlNew + "CsrService";
let ElasticSearch_NEW_URL_var = elasticUrl;
let OauthService_NEW_URL_var = baseUrlNew + "OauthService";

export const Image_URL = Image_URL_var;
export const AdminService_URL = AdminService_URL_var;
export const ThirdPartyService_URL = ThirdPartyService_URL_var;
export const PharmacistService_URL = PharmacistService_URL_var;
export const OrderManagementService_URL = OrderManagementService_URL_var;
export const CustomerService_URL = CustomerService_URL_var;
export const DoctorService_URL = DoctorService_URL_var;
export const CsrService_URL = CsrService_URL_var;
export const ReportService_URL = ReportService_URL_var;
export const ElasticSearch_URL = ElasticSearch_URL_var;
export const OauthService_URL = OauthService_URL_var;
export const WarehouseMumbaiService_URL = WarehouseMumbaiService_URL_var;
export const VendorConstant = VendorConstant_var;
export const PickerService_URL = Picker_URL_var;
export const CheckerService_URL = Checker_URL_var;

export const AdminService_NEW_URL = AdminService_NEW_URL_var;
export const AdminService_NEW_FDB = Admin_URL_FDB_var;
export const ThirdPartyService_NEW_URL = ThirdPartyService_NEW_URL_var;
export const PharmacistService_NEW_URL = PharmacistService_NEW_URL_var;
export const OrderManagementService_NEW_URL = OrderManagementService_NEW_URL_var;
export const CustomerService_NEW_URL = CustomerService_NEW_URL_var;
export const DoctorService_NEW_URL = DoctorService_NEW_URL_var;
export const CsrService_NEW_URL = CsrService_NEW_URL_var;
export const ElasticSearch_NEW_URL = ElasticSearch_NEW_URL_var;
export const OauthService_NEW_URL = OauthService_NEW_URL_var;
